import styled from 'styled-components';

import { UserButton } from '../EngagementSection/styles';

const ForgetImg = styled.div`
  text-align: center;
  margin-top: 20px;
  > img {
    width: 100px;
    cursor: pointer;
  }
`;

const PasswordContent = styled.div`
  ${'' /* text-align: center;
  font-size: 20px;
  margin-bottom: 20px;
  margin-top: 20px; */}
`;

const SubmitContainer = styled.div`
  width: 100%;
  ${'' /* margin-bottom: 20px; */}
  display: flex;
  justify-content: center;
  align-items: center;
 .SubmitBtn {
  margin-top: 16px;
  font-family: Lato, sans-serif;
  font-size: 16px;
  text-transform: capitalize;
  background: #F37A65;   /* not disabled */
  color: #FFFFFF;
  border: none;
  cursor: pointer;
}

.SubmitBtn:disabled {
  background: #EFEFEF;   /* disabled */
  color: #989898;
  cursor: not-allowed;
}

.SubmitBtn:hover:not(:disabled) {
  background: #E76A55;
 }
  @media (max-width: 500px) {
    width: 100%;
    margin-left: 0px;
  }
`;

const ErrorContainer = styled.div`
  width: 100%;
  @media (max-width: 500px) {
    width: 100%;
    margin-left: 0px;
  }
  > li {
    display: block;
    margin-left: 6px;
  }
`;

const Error = styled.div`
  width: 100%;
  margin-left: 0px;
> li {
  display: block;
  margin-left: 5px;
  margin-bottom: 20px;
}
`;

const SubmitButton = styled(UserButton)`
  cursor: ${({disabled}) => disabled ? 'not-allowed !important' : 'pointer'};
  ${'' /* opacity: ${({disabled}) => disabled && '0.5'}; */}

`;

export { SubmitButton, Error, ErrorContainer, ForgetImg, PasswordContent, SubmitContainer };
